import script from "./PlanCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanCards.vue?vue&type=script&setup=true&lang=ts"

import "./PlanCards.vue?vue&type=style&index=0&id=9070a41e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9070a41e"]])

export default __exports__